import {
  alertMessagesArgsConfig,
  collectionArgsConfig,
  collectionFieldArgsConfig,
} from '../../utils/event_constants';

export const pdfViewerActions = [
  {
    name: 'FileViewerOpen',
    label: 'Open PDF Viewer',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'collectionRequest', label: 'Select Field of File' }),
      ...alertMessagesArgsConfig,
    ],
  },
];
